import React from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Flex from 'base/components/Flex';
import OfflineDocuments from '../OfflineDocumentsPage/OfflineDocuments';

class OfflineAppMain extends React.PureComponent {
  componentDidMount() {
  }

  render() {
    return (
      <Flex className="app__main" flexDirection="column">
        <OfflineDocuments />
      </Flex>
    );
  }
}
OfflineAppMain.propTypes = {
};

const mapDispatchToProps = {
};

export default connect(
  null,
  mapDispatchToProps,
)(OfflineAppMain);
